import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { getCookie } from './getCookie';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

export function secureApiInterceptor(request: HttpRequest<unknown>, next: HttpHandlerFn) {
  // Check if we're running in the browser
  const platformId = inject(PLATFORM_ID);
  const isBrowser = isPlatformBrowser(platformId);

  // Always include credentials for all requests
  if (isBrowser) {
    const setHeaders: Record<string, string> = {};

    const xsrfToken = getCookie('XSRF-TOKEN');
    if (xsrfToken) {
      setHeaders['X-XSRF-TOKEN'] = xsrfToken;
    }

    const clonedRequest = request.clone({
      withCredentials: true,
      setHeaders,
    });

    return next(clonedRequest);
  }

  return next(request);
}
